import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // 👈 Must match exactly
// Loaded AFTER App so its transitive page CSS is in the bundle first — this
// lets the app-wide mobile overrides win the cascade. See src/styles/mobile.css.
import './styles/mobile.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
